











/** @format */

import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import AddEditGangStop from './components/add-edit-gang-stop.vue';
import { GANG_STOP } from '../router-names';
import { baseSentryInfo } from '@/api/parking-lot-management/index';
import { Mutation } from 'vuex-class';
import { CLOSE_CURRENT_TAB } from '@/store/mutation-types';
@Component({
  components: { AddEditGangStop }
})
export default class GangStopEdit extends Vue {
  path = '/smart-parking/parking-lot-management/gang-stop/';

  @Mutation(`pageTabs/${CLOSE_CURRENT_TAB}`)
  closeCurrentTab!: Function;
  headTitle = '岗亭编辑'; // 标题
  formData = {}; // 表单数据
  sentryId = '';
  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '岗亭信息',
        location: {
          name: GANG_STOP
        }
      },
      {
        label: this.headTitle
      }
    ];
  }
  // 生命周期初始化
  created() {
    this.sentryId = this.$route.params.id;
    this.queryEditPark();
  }
  // 获取数据赋值
  async queryEditPark() {
    try {
      const { status, code, msg, data } = await baseSentryInfo({ id: this.sentryId });
      this.formData = { ...data };
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    }
  }
  // 返回
  goBack() {
    // 清除当前tab页签
    this.closeCurrentTab();
    // 页面返回
    this.$router.replace({
      name: GANG_STOP
    });
  }
}
